import { useQuery } from "@tanstack/react-query";
import { Booking, BookingRequest } from "../../types/booking";
import { sortBy } from "lodash";
import dayjs from "dayjs";

import { useRecoilValue } from "recoil";
import { idTokenState } from "../../atoms/auth";

export const fetchRequests = async (
  idToken: string
): Promise<BookingRequest[]> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/booking-requests`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    }
  );
  if (!response.ok) {
    throw new Error("Failed to fetch bookings");
  }

  const data = await response.json();

  return sortBy(data.bookings as any, (booking) =>
    dayjs(booking.created_at).unix()
  );
};

export const useGetRequests = () => {
  const idToken = useRecoilValue(idTokenState);
  return useQuery(["requested-bookings"], () => fetchRequests(idToken!), {
    enabled: !!idToken,
  });
};
